<template>
  <Dialog
    v-model="isOpen"
    v-bind="filteredAttrs"
    :persistent="dataLoading || saveInProgress"
    @save="emit('save')"
    @cancel="$emit('cancel')"
  >
    <template
      v-if="dataLoading"
      #content
    >
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
    </template>
    <template
      v-else
      #content
    >
      <div v-if="order === null">
        {{ $t("Order not found") }}
      </div>
      <Dropdown
        v-model="selectedTestObject"
        :label="$t('Test')"
        :items="tests"
        :item-title="(i: any) => i.name"
        :item-value="'formTestId'"
        :return-object="true"
        :disabled="saveInProgress"
      />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed,  useAttrs, PropType } from "vue";
import Dialog from "@/components/dialogs/Dialog.vue";
import Dropdown from "@/components/input-components/Dropdown.vue";
import {Order} from "@/entities/order";
import {FormTest} from "@/entities/form-test";

defineOptions({ name: "OrderTestChangeDialog", inheritAttrs: false });

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  tests: {
    type: Array as () => FormTest[],
    default: () => [],
  },
  dataLoading: {
    type: Boolean,
    required: true,
    default: false,
  },
  order: {
    type: Object as PropType<Order | null>,
    required: true,
    default: null,
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'cancel'): void
  (e: 'save'): void
  (e: 'update:order', order: Order): void
}>()

const attrs = useAttrs();

const isOpen = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

const filteredAttrs = computed(() => {
  const { modelValue, ...rest } = attrs;
  return rest;
});

const selectedTestObject = computed({
  get: () => {
    if (!props.order || !props.tests.length) return null;
    return props.tests.find(t => t.formTestId === props.order?.formTestId) || null;
  },
  set: (newTest: any) => {
    if (props.order && newTest) {
      emit("update:order", {
        ...props.order,
        formTestId: newTest.formTestId,
        formTestName: newTest.name
      });
    }
  }
});

const saveInProgress = computed(
  () => !!attrs["save-in-progress"]
);
</script>
